import { render, staticRenderFns } from "./vehicleDetailInfo.vue?vue&type=template&id=620a4b30&scoped=true&"
import script from "./vehicleDetailInfo.vue?vue&type=script&lang=js&"
export * from "./vehicleDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a4b30",
  null
  
)

export default component.exports